import { Typography } from "@material-ui/core"
import { formatPrice } from "common/price"
import { Font } from "components/mapPages/showRooms/ShowRoomItem"
import { useTypedSelector } from "store"
import styled from "styled-components"

const StyledText = styled(Typography)`
  color: ${(p) => p.theme.colors.disable};
  font-size: 10px;
  line-height: 130%;
  font-weight: 300;
  font-family: ${Font.OENaPro};
  letter-spacing: inherit;
`

const LicensingFee = () => {
  const { licensingFee } = useTypedSelector((state) => state.wizard)

  if (!licensingFee) return null

  return (
    <StyledText>
      כולל מע&#34;מ ואגרת רישוי בסך {formatPrice(licensingFee.totalPrice)}.
      <br />
      בהתאם ל{licensingFee.annualPriceCatalogText.trim()}.
    </StyledText>
  )
}

export default LicensingFee
